import axios from 'axios';
import { CodeResponse } from '../../../interfaces/interfaceServices';
import { redirectTo } from '../navigationService';

const deleteToken = () => {
  localStorage.removeItem('accessToken');
  redirectTo('/');
};

export const sendVerificationCode = async (
  phoneNumber: string,
  codeLength: number = 6
): Promise<CodeResponse | undefined> => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/identity-validation-bff/v1.0.0/otp`;
  const token = localStorage.getItem('accessToken');

  if (!token) {
    console.error('Token no encontrado. Por favor, inicia sesión nuevamente.');
    redirectTo('/');

    throw new Error('No se encontró el token de acceso');
  }

  try {
    const response = await axios.post(
      apiUrl,
      { phoneNumber, codeLength },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'x-business': 'GASCO',
          'x-commerce': 'GASCO',
          'x-country': 'CL',
          'x-system': 'IdentityValidation',
          'x-user': 'GASCO_USER',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'Error al enviar el código de verificación:',
        error.response ? error.response.data : error.message
      );

      const errorMessage = (error.response?.data || '')
        .toString()
        .trim()
        .toLowerCase();
      if (errorMessage === 'invalid token') {
        deleteToken();
      }
    } else {
      console.error('Error inesperado:', error);
    }
    throw error;
  }
};
